export default __webpack_public_path__ + "landing2.120f1f11.jpg";